import React, { MutableRefObject } from "react";

export const SwipeFiltersContext = React.createContext<
  | {
      swipeActiveRef: MutableRefObject<boolean>;
    }
  | undefined
>(undefined);
